/** @jsxImportSource theme-ui */
import { Container, Heading, Text } from 'theme-ui';
import ConnectDiscountAgreement from '@/containers/dicountAgreements/ConnectDiscountAgreement';
import { useParams, useNavigate } from 'react-router-dom';
import Section from '@/components/Section';

const CreateDiscountAgreementPage = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();

    return (
        <Container>
            <Heading sx={{ textTransform: 'capitalize' }} as="h2">
                Connect Discount Agreement
            </Heading>
            <Section>
                <Heading as="h3">
                    Connect discount agreement <Text color="info">{id}</Text> to the subscription
                    for the selected company/company owner
                </Heading>
                <ConnectDiscountAgreement
                    discountAgreements={[{ DiscountAgreementId: id }]}
                    onSubmitSuccess={() => navigate('/voss/discount-agreements')}
                />
            </Section>
        </Container>
    );
};

export default CreateDiscountAgreementPage;
